import { TextField } from '@mui/material';
import React, { ComponentProps, FC, forwardRef } from 'react';
import { InputAttributes, NumberFormatValues, NumericFormat } from 'react-number-format';
import { UseFormReturn } from 'react-hook-form';
import { ControlledInput } from '../controlled-input/controlled-input.component';

type Props = ComponentProps<typeof TextField> & {
    name: string;
    form?: UseFormReturn;
    decimalScale?: number;
};

interface NumberFormatProps {
    onChange: (event: { target: { name: string; value: string } }) => void;
    name: string;
    decimalScale?: number;
}

export const NumberInput = forwardRef<typeof NumericFormat<InputAttributes>, NumberFormatProps>(
    ({ onChange, name, decimalScale = 2, ...other }, ref) => {
        return (
            <NumericFormat
                {...other}
                getInputRef={ref}
                onValueChange={(values: NumberFormatValues) => {
                    onChange({
                        target: {
                            name: name,
                            value: values.value,
                        },
                    });
                }}
                allowLeadingZeros
                allowedDecimalSeparators={['.', ',']}
                thousandSeparator=" "
                decimalSeparator=","
                valueIsNumericString
                allowNegative={false}
                decimalScale={decimalScale}
            />
        );
    },
);

export const ControlledNumberInput: FC<Props> = ({ slotProps, decimalScale, ...textFieldProps }) => {
    return (
        <ControlledInput
            slotProps={{
                ...slotProps,
                input: { inputComponent: NumberInput as any, ...slotProps?.input },
                htmlInput: { decimalScale, ...slotProps?.htmlInput },
            }}
            {...textFieldProps}
        />
    );
};
